// Purges browser state left by a previous incompatible version of the app
// (old JWT format / hashing, old userData shape). Runs before anything else
// reads localStorage (router redirect, ACL ability, jwt service), so stale
// state can never break the boot sequence.
// Bump APP_VERSION whenever a deploy invalidates stored tokens or user data.
const APP_VERSION = 'prophasud-2026-08-29'

try {
    if (localStorage.getItem('appVersion') !== APP_VERSION) {
        localStorage.clear()
        localStorage.setItem('appVersion', APP_VERSION)
    }
} catch (e) {
    // Storage unavailable (private mode with blocked storage) — nothing to purge.
}

// One-time reset of the local items database. Delta sync and the blocked-items
// purge can only fix codes the backend knows about: stale records from earlier
// eras (old portal, type changes, the 2026-09-05 blocked-flags incident) linger
// as orphans forever. Bump ITEM_DB_RESET to force every browser to drop the
// items db and re-download a clean copy once (localStorage/session untouched,
// so the customer stays logged in). deleteDatabase is requested before the app
// opens the db, so the later open() queues behind the deletion — safe order.
const ITEM_DB_RESET = '2026-09-05'
try {
    if (localStorage.getItem('itemDbReset') !== ITEM_DB_RESET) {
        indexedDB.deleteDatabase('itemsDatabase')
        localStorage.removeItem('lastItemUpdate')
        localStorage.removeItem('lastBlockedSync')
        localStorage.setItem('itemDbReset', ITEM_DB_RESET)
    }
} catch (e) {
    // IndexedDB unavailable — the app falls back to a full download anyway.
}

// The previous portal registered a service worker in customers' browsers; it
// intercepts all requests and can keep serving the old app even after F5.
// Unregister anything found so this app is always served by the network.
try {
    if (navigator.serviceWorker && navigator.serviceWorker.getRegistrations) {
        navigator.serviceWorker.getRegistrations().then(function (registrations) {
            registrations.forEach(function (registration) { registration.unregister() })
        })
    }
} catch (e) {
    // Service workers unsupported — nothing to clean.
}
